export const GRADE_LEVELS = [9, 10, 11, 12];
export const SUBJECTS = [
  'BIOLOGY',
  'BUSINESS',
  'CHEMISTRY',
  'CIVICS',
  'ECONOMICS',
  'ENGLISH',
  'GEOGRAPHY',
  'HISTORY',
  'MATHS',
  'PHYSICS',
];

export const REPORTS = [
  'MISLEADING INFORMATION',
  'CODE OF CONDUCT VIOLATION',
  'COPYRIGHT',
  'SPAM',
  'OTHER',
];

export const FETCH_LIMIT = 10;
